import { Component, Input } from '@angular/core';

/** Card-level failure state of a dashboard page; shows the server's validation text when a 400 carried one. */
@Component({
  selector: 'ifbp-snapshot-error-card',
  templateUrl: './snapshot-error-card.component.html',
  styleUrls: ['./snapshot-error-card.component.scss'],
  standalone: false,
})
export class SnapshotErrorCardComponent {
  @Input() message: string | null = null;
  /** Shown when the failure carried no server message. Page-agnostic by default; each page may name itself. */
  @Input() fallbackMessage = 'This dashboard is unavailable right now. Change the period or scope to try again.';
}
